<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 文件资源</el-breadcrumb-item>
                <el-breadcrumb-item>文件资源下载认证</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0' label='项目名'>
                                <el-select filterable clearable size='mini' v-model='queryParams.projectAppId'
                                           placeholder='项目名'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.id'
                                        :label='item.cnName'
                                        :value='item.appId'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='资源uri'>
                                <el-input v-model='queryParams.uri' size='mini' placeholder='请输入资源uri' />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='tableList'
                      @sort-change='handleSortChange'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column :show-overflow-tooltip='true' align='center' label='项目名'>
                    <template slot-scope='scope'>
                        <span>{{ projectInfoMap.get(scope.row.projectAppId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='资源uri' prop='uri' />
                <el-table-column align='center' label='是否开启鉴权'>
                    <template slot-scope='scope'>
                        <el-tag :type="scope.row.status ? 'success' : 'danger'">
                            {{ scope.row.status ? '开启' : '未开启' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' sortable='custom' label='最后修改时间'
                                 prop='updateTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='60%'>
                <el-form label-position='left' ref='form' label-width='150px'>
                    <el-form-item label='选择项目' prop='url'>
                        <el-select filterable clearable size='mini' v-model='currentTableData.projectAppId'
                                   placeholder='请选择' @change='queryProduct'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.id'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='需鉴权的uri' prop='uri'>
                        <el-input size='mini' v-model='currentTableData.uri'
                                  placeholder='支持文件和文件夹uri, 存在多个相似uri时, 服务器选择会匹配的一个uri' />
                    </el-form-item>
                    <el-form-item label='是否开启鉴权' prop='url'>
                        <el-select filterable clearable size='mini' v-model='currentTableData.status'
                                   placeholder='请选择'>
                            <el-option
                                v-for='item in serviceStatusOptions'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='需登录'>
                        <el-switch
                            v-model='authConfig.loginLimit'
                            active-color='#13ce66'
                            inactive-color='#ff4949'>
                        </el-switch>
                    </el-form-item>
                    
                    <el-form-item label='商品购买校验'>
                        <el-switch
                            v-model='authConfig.orderStatus'
                            @change='handleOrderChange'
                            active-color='#13ce66'
                            inactive-color='#ff4949'>
                        </el-switch>
                        
                        <div v-if='authConfig.orderStatus' style='margin-top: 1rem;'>
                            <el-alert
                                description='会验证该用户的历史订单中, 订单状态处于[退款中]或[已成功支付]的订单, 只有存在其一, 便可允许用户访问文件资源'
                                type='success' />
                            
                            <el-select filterable clearable size='mini' v-model='authConfig.orderCondition.productId'
                                       placeholder='请选择商品'>
                                <el-option
                                    v-for='item in productList'
                                    :key='item.id'
                                    :label='`${item.name}_${item.productId}`'
                                    :value='item.id'>
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    
                    <el-form-item label='云存储数据校验'>
                        <el-switch
                            v-model='authConfig.cloudStorageStatus' active-color='#13ce66' inactive-color='#ff4949'>
                        </el-switch>
                        
                        <div v-if='authConfig.cloudStorageStatus && currentTableData.projectAppId'
                             style='margin-top: 1rem;'>
                            <el-alert
                                description="自定义云存储查询条件,只要执行该条件,查询到的条数大于等于1,便可允许用户访问文件资源 注:条件值可使用占位符 '{userId}' , 运行时该占位符会替换为玩家userId(如果登录)'"
                                type='success' />
                            
                            <project-cloud-storage @appChange='handleCloudAppChange'
                                                   :selected-app-id='authConfig.cloudCondition ? authConfig.cloudCondition.appId : undefined'
                                                   :selected-class-name='authConfig.cloudCondition ? authConfig.cloudCondition.className : undefined'
                                                   :project-app-id='currentTableData.projectAppId'>
                                <template #default='scope'>
                                    <el-form-item label='查询条件'
                                                  v-if='scope.chooseApp && scope.chooseApp.schemaOptions && scope.chooseApp.schemaOptions.queryFieldType'>
                                        <class-filter
                                            :initial-where='authConfig.cloudCondition ? authConfig.cloudCondition.where : undefined'
                                            :key='`${scope.chooseApp.appId}_${scope.chooseApp.schemaOptions.value}`'
                                            :all-type='scope.chooseApp.schemaOptions.queryFieldType'
                                            @getFilterCondition='handleGetFilterCondition' query-button-text='使用' />
                                        <template>
                                            <el-alert
                                                title='条件修改后需要先点击使用'
                                                type='warning'>
                                            </el-alert>
                                        </template>
                                    </el-form-item>
                                </template>
                            </project-cloud-storage>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import DynamicForm from '@/components/component/DynamicForm.vue';
import { resourceDownloadAuthApi } from '@api/project/resourceDownloadAuthApi';
import { selProduce } from '@api/produce';
import PayCloudStorageMapping from '@/components/component/product/PayCloudStorageMapping.vue';
import ProjectCloudStorage from '@/components/component/product/ProjectCloudStorage.vue';
import ClassFilter from '@/components/component/storage/ClassFilter.vue';

export default {
    name: 'AppMd5',
    components: { ClassFilter, ProjectCloudStorage, PayCloudStorageMapping, DynamicForm, CottonFileUpload },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined,
                uri: undefined,
                sortSqlList: [
                    'createTime desc'
                ]
            },
            updateStatus: false,
            projectInfoMap: new Map,
            projectInfoNameMap: new Map,
            projectInfoList: [],
            
            tableList: [],
            currentTableData: {},
            serviceStatusOptions: [
                {
                    label: '开启',
                    value: true
                },
                {
                    label: '关闭',
                    value: false
                }
            ],
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            authConfig: {
                loginLimit: true,
                orderStatus: false,
                cloudStorageStatus: false,
                cloudCondition: {
                    appId: undefined,
                    className: undefined,
                    where: undefined
                },
                orderCondition: {
                    productId: undefined
                }
            },
            productList: []
        };
    },
    computed: {
        computeStatusLabel() {
            return (status, t) => {
                const option = this.serviceStatusOptions.find(
                    item => item.value === status
                );
                return option ? option.label : '未知状态';
            };
        }
    },
    created() {
        this.getList();
        
        // 查询项目信息
        queryProjectInfoList({ pageSize: 100000 }).then(result => {
            if (result.code === 200) {
                if (result.data && result.data.result) {
                    result.data.result.forEach(v => {
                        this.projectInfoList.push(v);
                        this.projectInfoMap.set(v.appId, v.cnName);
                        this.projectInfoNameMap.set(v.appId, v.name);
                    });
                }
            }
        });
    },
    methods: {
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            resourceDownloadAuthApi.query(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.tableList = response.data.result;
                    this.queryParams.total = response.data.total;
                    
                    this.queryParams.pageNum = response.data.pageNum;
                }
                this.loading = false;
            });
        },
        /** 提交按钮 */
        async submitForm() {
            if (!this.currentTableData.projectAppId) {
                message.error('项目名未选择!');
                return;
            }
            
            if (!this.currentTableData.uri) {
                message.error('uri缺失');
                return;
            }
            
            if (!this.currentTableData.uri.startsWith('/')) {
                this.currentTableData.uri = '/' + this.currentTableData.uri;
            }
            
            this.currentTableData.config = this.authConfig;
            if (!this.authConfig.orderStatus) {
                this.currentTableData.config.orderCondition = null;
            }
            if (!this.authConfig.cloudStorageStatus) {
                this.currentTableData.config.cloudCondition = null;
            }
            
            if (this.updateStatus) {
                resourceDownloadAuthApi.update(this.currentTableData).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                if (!this.currentTableData.status) {
                    this.currentTableData.status = true;
                }
                resourceDownloadAuthApi.insert(this.currentTableData).then(result => {
                    if (result.code === 200) {
                        // 添加游戏的下载渠道
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return resourceDownloadAuthApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        async handleSortChange({ column, prop, order }) {
            let sortType = null;
            if (order === 'ascending') {
                sortType = 'ASC';
            } else if (order === 'descending') {
                sortType = 'DESC';
            }
            
            let newSortSql = prop + ' ' + sortType;
            if (this.queryParams.sortSqlList.length > 0) {
                let sortAddStatus = false;
                for (let i = 0; i < this.queryParams.sortSqlList.length; i++) {
                    let sortSql = this.queryParams.sortSqlList[i];
                    if (sortSql.indexOf(prop) !== -1) {
                        // 存在排序sql
                        this.queryParams.sortSqlList.splice(i, 1);
                        if (order) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                        sortAddStatus = true;
                    }
                    if (i === this.queryParams.sortSqlList.length - 1) {
                        if (!sortAddStatus) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                    }
                }
            } else {
                this.queryParams.sortSqlList.push(newSortSql);
            }
            this.getList();
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined,
                sortSqlList: [
                    'createTime desc'
                ],
                uri: undefined
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增项目服务器状态';
            this.updateStatus = false;
            this.currentTableData = {};
            
            this.authConfig = {
                loginLimit: true,
                orderStatus: false,
                cloudStorageStatus: false,
                cloudCondition: {
                    appId: undefined,
                    className: undefined,
                    where: undefined
                },
                orderCondition: {
                    productId: undefined
                }
            };
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改项目服务器状态';
            this.updateStatus = true;
            this.currentTableData = deepCopy(row);
            this.open = true;
            
            this.authConfig = {
                loginLimit: true,
                orderStatus: false,
                cloudStorageStatus: false,
                cloudCondition: {
                    appId: undefined,
                    className: undefined,
                    where: undefined
                },
                orderCondition: {
                    productId: undefined
                }
            };
            
            if (this.currentTableData.config) {
                this.authConfig.loginLimit = this.currentTableData.config.loginLimit;
                if (this.currentTableData.config.orderCondition) {
                    this.authConfig.orderStatus = true;
                    this.authConfig.orderCondition = this.currentTableData.config.orderCondition;
                }
                if (this.currentTableData.config.cloudCondition) {
                    this.authConfig.cloudStorageStatus = true;
                    this.authConfig.cloudCondition = this.currentTableData.config.cloudCondition;
                }
            }
            
            console.log(this.authConfig);
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return;
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + ' 00:00:00';
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + ' 23:59:59';
            this.refresh();
        },
        handleOrderChange(value) {
            if (value) {
                if (!this.currentTableData.projectAppId) {
                    message.error('请先选择项目');
                    this.authConfig.orderStatus = !value;
                    return;
                }
                this.queryProduct();
                this.authConfig.loginLimit = true;
            }
        },
        queryProduct() {
            if (this.authConfig.orderStatus && this.currentTableData.projectAppId) {
                selProduce({
                    projectName: this.projectInfoNameMap.get(this.currentTableData.projectAppId)
                }).then(res => {
                    if (res.status === 200) {
                        this.productList = res.data.data.records;
                        if (this.productList.length === 0) {
                            message.error('该项目下没有任何商品 请先增加商品');
                        }
                    }
                });
            }
        },
        handleCloudAppChange(value) {
            this.authConfig.cloudCondition.appId = value.appId;
            this.authConfig.cloudCondition.className = value.schemaOptions.value;
        },
        handleGetFilterCondition(value) {
            console.log('当前使用的条件', value);
            console.log('\\\\');
            this.authConfig.cloudCondition.where = value;
        }
    }
};
</script>
<style>

</style>
